module.exports = __webpack_public_path__ + "6504abb46cfd2190c9c32eb4ad92453f.png";